import { USER_AUTH_KEY } from "../../utils/constants";
import { mergeArrayOfObjects } from "../../utils/mergeArrayOfObjects";

export default async email => {
  const baseApiUri = process.env.REACT_APP_CLIENT_CONFIG_API_DOMAIN;
  const encodedEmail = encodeURIComponent(email);
  const response = await fetch(
    `${baseApiUri}/rpc/users/?email=${encodedEmail}`
  );
  const {
    results: [user]
  } = await response.json();
  const userRoles = [...new Set(user.roles.map(role => role.name))];
  let userClients = user.clients;
  const orgIds = [];
  let role = userRoles.includes("Data Steward") ? "Data Steward" : "Read-Only";

  let readOnlyClients = [];
  let userRolesResults = [];
  try {
    const responseUserRoles = await fetch(
      `${baseApiUri}/rpc/user_roles/?user__id=${user.id}`
    );
    const userRolesData = await responseUserRoles.json();
    userRolesResults = await userRolesData.results;
    for (const userRole of userRolesResults) {
      if (userRole.role.name === "Read-Only") {
        readOnlyClients.push(userRole.client.name);
      }
    }
  } catch (e) {
    console.log("Error while calling user_roles api", e);
  }

  // if (userRoles.includes("Global Admin")) {
  //   // Global admin should only be associated with Global Org and Account
  //   // but have access to all the orgs and accounts. This will fetch all the
  //   // orgs and associated them to the global user.

  //   const responseClients = await fetch(`${baseApiUri}/rpc/clients/`);
  //   const clientsData = await responseClients.json();
  //   userClients = clientsData.results;

  //   role = "Global Admin";
  // } else
  if (userRoles.includes("Organization Admin")) {
    // Based on the conversation with Sarah:
    // User can have multiple Organization Admin and also Data steward role with different clients/accounts

    // If a user has admin access to any client/account then it has admin
    // access to all accounts. This will fetch the accounts that are associated
    // with the Orgs that the user is associated with.

    // This will fetch user_role/client mapping.
    for (const userRole of userRolesResults) {
      if (userRole.role.name === "Organization Admin") {
        orgIds.push(userRole.client.organization.id);
      }
    }

    // This will add all clients associated with org, updates userClients uniquely.
    for (const orgId of orgIds) {
      const clients = await fetch(
        `${baseApiUri}/rpc/clients/?organization__id=${orgId}`
      );
      const clientsData = await clients.json();
      userClients = mergeArrayOfObjects(userClients, clientsData.results, "id");
    }

    role = "Organization Admin";
  }
  // This value should come along with other saved preferences
  // from the fetch user call; for now using localStorage
  const sessionUser = window.localStorage.getItem(USER_AUTH_KEY)
    ? JSON.parse(window.localStorage.getItem(USER_AUTH_KEY))
    : null;
  const sessionClientId = sessionUser
    ? sessionUser.preferences.selectedClient.id
    : null;
  // Verify that the user still has access to the saved client
  // or default to the only client available
  const sessionClient =
    user.clients.length > 1
      ? user.clients.find(client => `${client.id}` === sessionClientId)
      : user.clients[0];
  const selectedClient =
    sessionClientId && sessionClient ? sessionClient : null;

  userClients.sort((clientA, clientB) =>
    clientA.name.toLowerCase() <= clientB.name.toLowerCase() ? -1 : 1
  );

  return {
    id: user.id,
    username: user.email,
    firstName: user.first_name,
    lastName: user.last_name,
    orgIds, //if user is org admin, orgIds will have list of ids for which user has admin access, otherwise it will be empty
    clients: userClients,
    readOnlyClients: readOnlyClients,
    preferences: {
      timeZone: "America/Chicago",
      selectedClient
    },
    role
  };
};
